import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {  close } from "../../../../modules/modals";
import DeleteConfirmation from "../../../../Components/AdminConsole/modal/deleteConfirmation";
import { GLOBAL_MODALS } from "../../../../constant";


const mapStateToProps = (state, ownProps) => {
    
    const {
	modal: { show, modalType,  data},
	AdminAuth:auth,
	lang
    } = state;

  return {
      show: show && modalType === GLOBAL_MODALS.DELETE_CONFIRMATION_MODAL,
      data,
      auth,
      lang
  };
};

const mapDispatchToProps = dispatch => {
  return {
      close: () => dispatch(close()),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(DeleteConfirmation)
);
